import {TabsComponent} from "../../../styleguide/js/components/tabs/tabs";

window.pew.addRegistryEntry({key: 'wdf-tabs', domSelector: '.wdf-tabs', classDef: TabsComponent});